<script>
export default {
  name: "BaseVuexFormItem",
  props: {
    bind: {
      type: String,
      required: true,
    }
  },
  data() {
    return {
      vuex_module: '',
      vuex_column: '',
    }
  },
  inject: ['bindModule'],
  emits: ['change'],
  created() {
    if (this.bindModule) {
      this.vuex_module = this.bindModule;
      this.vuex_column = this.bind;
    } else {
      const splitBind = this.bind.split('/');
      this.vuex_column = splitBind.pop();
      this.vuex_module = splitBind.join('/');
    }
  },
  computed: {
    value: {
      get() {
        return this._getter(this.vuex_column);
      },
      set(value) {
        this._commit(this.vuex_column, value);
        this.$emit('change', this.value);
      },
    },
    errorMessage() {
      return this.$store.state[this.vuex_module]?.errors?.[this.vuex_column]?.[0];
    },
  },
  methods: {
    _convertSnakeToCamel(value) {
      return value.replace(/_./g, (char) => (char.charAt(1).toUpperCase()));
    },
    _getter(vuexColumn) {
      // 固有のgetterが実装されていればそれを優先する
      const getterName = this.vuex_module + '/' + this._convertSnakeToCamel(vuexColumn);
      if (getterName in this.$store.getters) {
        return this.$store.getters[getterName];
      }
      return this.$store.state[this.vuex_module]?.data[vuexColumn];
    },
    _commit(vuexColumn, value) {
      // 固有のmutationが実装されていればそれを優先する
      const mutationName = this.vuex_module + '/' + this._convertSnakeToCamel(vuexColumn);
      if (mutationName in this.$store._mutations) {
        this.$store.commit(mutationName, {value: value});
      } else {
        this.$store.commit(this.vuex_module + '/inputFormItem', {column: vuexColumn, value: value});
      }
    },
  }
}
</script>
